import { dispatchStoryStart, dispatchVariantStart } from '../events';
import { getInactivePlayer } from '../helpers';
import videojs from 'video.js';

export function isEmbed(player) {
  return player.el().hasAttribute('data-embed-api');
}

/**
 * Returns the element that'll start the video playback
 * accounting for whether the player is embedded or not
 * @param {*} player
 * @returns Element
 */
export function startButton(player) {
  if (isEmbed(player)) {
    return player.el().querySelector('.vjs-play-control');
  } else {
    return player.bigPlayButton;
  }
}

const CLASS_STORY_STARTED = 'wrp-player-story-started';

function hasStoryStarted(player) {
  player.el().classList.contains(CLASS_STORY_STARTED);
}

export function markStoryStart(player) {
  if (!hasStoryStarted(player)) {
    player.el().classList.add(CLASS_STORY_STARTED);

    const allPlayers = videojs.getAllPlayers();
    const hiddenPlayer = getInactivePlayer(allPlayers);

    hiddenPlayer.el().classList.add(CLASS_STORY_STARTED);

    dispatchStoryStart(player);
    // For non video islands we need to dispatch the variant start
    // as the story starts
    if (!player.isVideo) {
      dispatchVariantStart(player);
    }
  }
}
